<template lang="html">
    <div>
        <Heading :title="$t('about') + ' ' + capitalize($t('site_erv'))" :routeName="'vignette'"></Heading>
        <AboutErovContent/>
    </div>
</template>

<script>

import Heading from './snippets/Heading.vue'
import AboutErovContent from './AboutErovContent.vue'

export default {
    name: 'AboutErov',
    components: {
        Heading,
        AboutErovContent
    },
    props: {
    }
}

</script>

<style lang="scss" scoped>
</style>
